export const state = {
  accountId: '',
  loading: true,
  loadingId: false,
  isExternalAuth: false,
  assets: {},
  fields: {
    legal: [],
    natural: []
  },
  terms: '',
  position: '',
  userInfo: {},
  isApp: false,
  access_token: null,
  hidden_email: null,
  hidden_phone: null,
  user_email: '',
  contacts: null,
  smsChannel: false,
  request_id: '',
  message_sent: false,
  cooldown: 0,
  is_recover_sms: false,
  facebook_pixel_id: '',
  google_analytics_id: '',
  allowed_countries: [],
  selectedCountry: 'BRASIL',
  socialMedia: {},
  login_menu: false,
  delete_request: false,
  is_confirmed: false,
  show_delete_buttons: false,
  allowed_person_types_signup: [],
  allowed_modules: {},
  hotsiteLinks: [],
  finishScreenWhatsapp: {
    whatsapp_link: '',
    enable_whatsapp_link: false
  },
  appStores: {
    enable_apps: false,
    app_store_link: '',
    play_store_link: ''
  },
  currentCaptchaToken: null
}
